module.exports = __webpack_public_path__ + "img/89e32ab29244cbd18a31c90f1dd6d44b.svg";